import { useForm } from 'react-hook-form';
import { login } from '../../services/Login/authService';
import { tokenStorage, usernameStorage, userDataStorage, pinVerifiedStorage, permissionsStorage, clearAllAuthData } from '../../utils/encryptedCookie';

const useLoginForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    try {
      // Limpa todos os dados antigos antes do login
      clearAllAuthData();
      
      const result = await login(data.username, data.password);
      
      // Salva os dados de autenticação
      tokenStorage.set(result.token);
      usernameStorage.set(data.username);
      
      if (result.user) {
        userDataStorage.set(result.user);
        pinVerifiedStorage.remove();
        sessionStorage.removeItem(`pinVerified_${data.username}`);
      }
      
      // Debug: verifica se os cookies foram salvos
      console.log('🔍 Verificando cookies após login:');
      console.log('Token:', tokenStorage.get() ? '✅ Salvo' : '❌ Não encontrado');
      console.log('Username:', usernameStorage.get() ? '✅ Salvo' : '❌ Não encontrado');
      console.log('UserData:', userDataStorage.get() ? '✅ Salvo' : '❌ Não encontrado');
      
      return result;
    } catch (error) {
      throw new Error(error.message || 'Erro ao realizar login.');
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
  };
};

export default useLoginForm;